export default (circlesColors) => {
  return {
    'circle-radius': 6,
    'circle-stroke-opacity': 1,
    'circle-stroke-color': '#808080',
    'circle-stroke-width': 1,
    'circle-color': circlesColors,
  }
}
